import { useCallback } from 'react';
import { Flex, Switch } from '@banhala/ui-kit';
import type { HeadlineSmallOneLineToggleProps } from './types';
import { bridge, isNil } from '../../../../utils';
import { HTMLText } from '../../../HTMLText';
import type { IScreensLogging } from '../../../../api/types';
import { useFilterListAtom } from '../../ItemList/FilterList/Provider/filterList/useFilterListAtom';

export const HeadlineSmallOneLineToggle = ({
  header,
  scrollToFilterList,
}: HeadlineSmallOneLineToggleProps) => {
  const { setFilterListAtom } = useFilterListAtom();

  const handleToggle = useCallback(
    (nextValue: boolean) => {
      if (isNil(header)) return;

      logClickToggle({ logging: header.logging, isOn: nextValue });

      scrollToFilterList?.();
      setFilterListAtom(prev => ({
        ...prev,
        [header.item.query_name]: nextValue
          ? [header.item.query_value]
          : undefined,
      }));
    },
    [header, scrollToFilterList, setFilterListAtom],
  );

  if (isNil(header)) return null;

  return (
    <Flex.Row
      padding={{ top: 24, bottom: 16, horizontal: 16 }}
      alignItems="center"
      justifyContent="space-between"
    >
      <Flex flex={1}>
        <HTMLText type="h5" color="content_primary">
          {header.item.title}
        </HTMLText>
      </Flex>
      <Switch value={header.item.is_on} onChange={handleToggle} />
    </Flex.Row>
  );
};

const logClickToggle = ({
  logging,
  isOn,
}: {
  logging: IScreensLogging;
  isOn: boolean;
}) => {
  bridge.logAnalyticsEvent({
    name: 'CLICK_HEADLINE_SMALL_ONE_LINE_TOGGLE',
    analytics: { ...logging.analytics, IS_ON: isOn },
    ably_only_log: logging.ably_only_log,
  });
};
